import { SectionShell } from '@/components/layout/SectionShell'

const localMachines = [
  'Mac Studio M1 Max, 64 GB Unified Memory',
  'Ryzen 9 5950X, Radeon AI PRO R9700',
  'Ryzen 9 5900XT, Radeon RX 9070 XT',
  'Ryzen 5 5600, GTX 1660 Super',
  'Ryzen R1600, DS 923+',
  
] as const

export function PhilosophySection() {
  return (
    <SectionShell
      id="philosophy"
      labelledBy="philosophy-heading"
      className="page-snap-section flex flex-col justify-center py-16 text-center sm:py-20"
    >
      <div className="terminal-neon-window reveal mx-auto w-full max-w-4xl rounded-xl px-6 py-20 sm:px-8 sm:py-24">
        <span
          aria-hidden="true"
          className="mx-auto mb-8 flex h-12 w-12 items-center justify-center text-primary terminal-glow"
        >
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-10 w-10"
          >
            <path d="M7 17h4l2-4V7H7v6h3zm8 0h4l2-4V7h-6v6h3z" />
          </svg>
        </span>
        <h2
          id="philosophy-heading"
          className="font-display text-4xl font-semibold italic tracking-[-0.045em] text-foreground sm:text-5xl md:text-[56px] md:leading-tight terminal-glow"
        >
          compute to build.
        </h2>

        <p className="mt-5 font-mono text-sm uppercase tracking-[0.38em] text-primary">.local</p>
        <div className="mx-auto mt-8 max-w-2xl space-y-3 text-sm leading-6 text-muted">
          {localMachines.map((machine) => (
            <p key={machine}>{machine}</p>
          ))}
        </div>
      </div>
    </SectionShell>
  )
}
